module.exports = __webpack_public_path__ + "static/media/NYU_Logo.565b9266.png";